import { render, staticRenderFns } from "./CommonTag.vue?vue&type=template&id=33f461da&scoped=true"
import script from "./CommonTag.vue?vue&type=script&lang=js"
export * from "./CommonTag.vue?vue&type=script&lang=js"
import style0 from "./CommonTag.vue?vue&type=style&index=0&id=33f461da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f461da",
  null
  
)

export default component.exports